export default "__VITE_ASSET__TbdG7jCMkTTKmCrZCLsSog__"